import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';

import { AuthService } from './authService.js';
import jwtDecode from 'jwt-decode';

export class LoginService {


    static httpPostLogin(user, password) {
        let randomuid='';
        if (SharedService.isRandomUser(AuthService.getUid())){
            randomuid = AuthService.getUid();
            randomuid = randomuid.replace(/"/g, "");
        }//postCrypto
        return SharedService.httpPostCrypto(ApplicationConstants.postLoginUrl, { user: user, password: password, randomuid: randomuid}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    throw "Error";
                }
                else {
                    AuthService.setToken(response.body.token);
                    AuthService.setUid(response.body.uid);
                    AuthService.setTipusEntitat(response.body.tipusEntitat);
                    return response.body;
                }
            }
        });
    }
    static httpPostLoginToken(token) {
        return SharedService.httpPost(ApplicationConstants.postLoginTokenUrl+token).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    throw "Error";
                }
                else {
                    AuthService.setToken(response.body.token);
                    AuthService.setUid(response.body.uid);
                    AuthService.setTipusEntitat(response.body.tipusEntitat);
                    return response.body;
                }
            }
        });
    }
    static isUserLogged() {
        var token='';
        if (AuthService.getToken() !== undefined && AuthService.getToken() !== null) {
            token = AuthService.getToken();
            var decoded = jwtDecode(token);
            var current_time = new Date().getTime() / 1000;
            if (current_time > decoded.exp) { //expired
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
        
    }
    static httpPostLogout(){
        return SharedService.httpPost(ApplicationConstants.postLogoutUrl).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    AuthService.deleteToken();
                    AuthService.deleteUid();
                    AuthService.deleteTipusEntitat();
                    throw "Error";
                }
                else {
                    AuthService.deleteToken();
                    AuthService.deleteUid();
                    AuthService.deleteTipusEntitat();
                    return response.body;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/login/services/loginService.js